import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { requiredPayloadEnvelope } from '../envelope.js';
const c = initContract();
/** admin-api 헬스 체크 — 로드밸런서·모니터링용 생존 신호다. */
export const adminHealthContract = c.router({
    get: {
        method: 'GET',
        path: '/health',
        responses: {
            200: requiredPayloadEnvelope(z.object({
                /** 서비스 상태 문자열이다. 정상이면 `ok`다. */
                status: z.string(),
                /** 응답을 낸 서비스 식별자다. */
                service: z.string(),
                /** 응답 시각의 ISO 8601 문자열이다. */
                timestamp: z.string(),
            })),
        },
    },
});
//# sourceMappingURL=health.contract.js.map